import { render, staticRenderFns } from "./dashboard.html?vue&type=template&id=37179eb2&scoped=true&external"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=37179eb2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37179eb2",
  null
  
)

export default component.exports